import { Box } from "@mui/material";
import styled from "styled-components";
import { DeviceType } from "../../utils/hooks/useDeviceHook";
import { StyledSelect } from "../shared/Select/Select.styles";
import { FieldTitle } from "../shared/TextField/FormField.styles";
import { StyledTextField } from "../shared/TextField/TextField.styles";
import { StyledTypography } from "../shared/Typography/Typography.styles";
import { ErrorPopupWrapper } from "../shared/ErrorPopup/ErrorPopup.styles";

const getProfileResetTextFieldWidth = (deviceType?: DeviceType) => {
  if (deviceType === "mobile") {
    return "330px";
  }
  if (deviceType === "tablet") {
    return "420px";
  }
  return "450px";
};

export const ProfileResetPasswordWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-rows: 20px 40px auto auto;
  grid-row-gap: 40px;
  padding: 25px 60px 0px 60px;
  ${({ deviceType }) => (deviceType === "mobile" ? "0px" : "20px")};
  background-color: ${({ theme }) => theme.white};
  place-items: center;

  ${StyledTypography} {
    place-self: flex-start;
    padding-left: 10px;
  }

  ${StyledTextField} {
    width: ${({ deviceType }) => getProfileResetTextFieldWidth(deviceType)};
  }
`;

export const MyProfileContainer = styled.div`
  margin: 20px auto;
  max-width: 920px;

  ${FieldTitle} {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.greyMedium} !important;
    margin-bottom: 2px;
  }
`;

export const UpdatePasswordButtons = styled.div`
  margin-top: 20px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 5px;
  button {
    font-family: light !important;
  }
`;

export const UpdatePasswordButton = styled.div`
  button {
    font-size: 16px !important;
  }
`;

export const MyProfileResetPasswordContainer = styled.div``;

export const CancelButton = styled.div`
  button {
    background-color: white !important;
    color: #433f3f !important;
    padding: 5px 20px !important;
    border: 1px solid #433f3f !important;
    font-family: light !important;
  }
`;

export const UpdateButton = styled.div`
  button {
    background-color: ${({ theme }) => theme.redMedium} !important;
    color: ${({ theme }) => theme.white} !important;
    padding: 5px 20px !important;
    font-family: light !important;
  }
`;

export const UpdatePasswordModalButtons = styled.div`
  display: flex;
  grid-gap: 8px;
  padding: 0px 30px 20px 0px;
  justify-content: flex-end;
`;

export const ErrorWrapper = styled.div`
  width: 100%;
  display: flex;
  ${ErrorPopupWrapper} {
    width: 90%;
    justify-self: center;
    margin-top: 15px;
    margin-bottom: 15px;
  }
`;

export const GeneralInfoWrapper = styled.div`
  padding: 12px;
  background-color: white;
  margin-bottom: 20px;
`;

export const GeneralInfoText = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 12px;
  padding-bottom: 10px;
`;

export const FieldRow = styled.div`
  display: flex;
  justify-content: space-between;
  grid-gap: 35px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    grid-gap: 0px;
  }
`;

export const EditReport = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  margin-top: 35px;

  @media (max-width: 600px) {
    button {
      width: fit-content !important;
      padding: 4px 24px !important;
    }
  }
`;

export const LogoutOutWrapper = styled.div`
  padding: 12px;

  button {
    padding: 4px 40px !important;
  }

  .edit-button {
    margin-top: 20px;
    margin-left: 5px;
  }

  @media (max-width: 600px) {
    button {
      width: fit-content !important;
      padding: 4px 30px !important;
    }
  }
`;

export const ProfileEmailNotificationsHeader = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.greyMedium} !important;
  svg {
    margin-bottom: -6px;
    margin-left: 4px;
    fill: ${({ theme }) => theme.redMedium};
  }
`;

export const ProfileEmailNotificationsOptionGrid = styled.div`
  display: grid;
  grid-template-rows: auto auto;
`;

export const ProfileEmailNotificationsOption = styled.div<{ indent?: boolean }>`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.black} !important;
  margin-left: ${({ indent }) => (indent ? "20px" : undefined)};
  svg {
    margin-bottom: -6px;
    margin-left: 4px;
    fill: ${({ theme }) => theme.redMedium};
  }
`;

export const ProfileEmailNotificationsGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(5, auto);
  grid-row-gap: 10px;
`;

export const ProfileEmailNotificationsGridLine = styled.div`
  border-bottom: 1px dashed #dbdee6;
`;

export const ProfileEmailNotificationsGridRows = styled.div<{
  none?: boolean;
}>`
  display: grid;
  grid-template-columns: 400px 175px auto;
  height: 55px;
  grid-gap: 20px;
  align-items: center;
  ${StyledSelect} {
    height: 40px;
    margin-top: -10px;

    .MuiButtonBase-root.Mui-selected {
      background-color: ${({ theme }) => theme.blueSubtle} !important;
      font-size: 20px;
    }
  }

  .select {
    font-style: normal !important;
    justify-content: flex-start !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: ${({ theme, none }) =>
      none ? theme.neutral500 : theme.black} !important;
  }

  .MuiInput-root.Mui-focused:after {
    border-bottom: 2px solid transparent;
  }

  @media (max-width: 768px) {
    grid-template-columns: none;
    grid-template-rows: auto auto auto;
    height: auto;
  }
`;
export const DisableSection = styled.div<{
  disable?: boolean;
}>`
  opacity: ${({ disable }) => (disable ? "0.5" : "1")};
  pointer-events: ${({ disable }) => (disable ? "none" : "auto")};
`;

export const ProfileEmailNotificationExplainer = styled.div<{
  none: boolean;
}>`
  font-weight: 400 !important;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme, none }) =>
    none ? theme.redMedium : theme.neutral600} !important;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ProfileEmailNotificationsButtonWrapper = styled(Box)`
  display: flex;
  gap: 15px;
  margin-top: 8px;
`;

export const ProfileEmailNotificationsSpinner = styled.div`
  text-align: center;
  width: 100px;
  img {
    width: 35px;
  }
`;
